import { LocationsLabels } from 'libs/shared-lib/interfaces/partner-web/locations';
import { m070c040DealerContact } from '../../shared/shared.de';

export const LOCATIONS_LABELS_DE: LocationsLabels = {
    headline: 'Unsere kompetenten Standorte',
    m070c040DealerContact,
};
